import React, { useEffect, useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import Reveal from '@/components/site/Reveal';
import SectionHeading from '@/components/site/SectionHeading';
import api from '@/lib/api';

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get('/testimonials').then((res) => setItems(res.data || [])).catch(() => {});
  }, []);

  if (!items.length) return null;

  const visible = (start, count = 3) => {
    const out = [];
    for (let i = 0; i < count; i++) {
      out.push(items[(start + i) % items.length]);
    }
    return out;
  };

  return (
    <section data-testid="home-testimonials" className="py-20 md:py-28 bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between gap-6">
          <Reveal>
            <SectionHeading kicker="Client voices" title="What landlords and occupiers say." subtitle="Testimonials from developers, GCC heads, retail brands, and coworking operators we've worked with." />
          </Reveal>
          <div className="hidden sm:flex items-center gap-2">
            <button onClick={() => setIdx((i) => (i - 1 + items.length) % items.length)} aria-label="Previous" className="flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-[#144726] hover:bg-[#144726] hover:text-white transition-colors" data-testid="testimonials-prev"><ChevronLeft className="h-5 w-5" /></button>
            <button onClick={() => setIdx((i) => (i + 1) % items.length)} aria-label="Next" className="flex h-10 w-10 items-center justify-center rounded-md border border-slate-200 text-[#144726] hover:bg-[#144726] hover:text-white transition-colors" data-testid="testimonials-next"><ChevronRight className="h-5 w-5" /></button>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-testid="testimonials-carousel">
          {visible(idx).map((t, i) => (
            <Reveal key={`${t.id}-${i}`} delay={i * 80}>
              <article data-testid="testimonial-card" className="relative h-full rounded-xl border border-slate-200 bg-white p-7 shadow-sm">
                <Quote className="absolute right-5 top-5 h-10 w-10 text-[#C6A35B]/15" />
                <div className="flex items-center gap-1 text-[#C6A35B]">
                  {Array.from({ length: t.rating || 5 }).map((_, ii) => <Star key={ii} className="h-4 w-4 fill-current" />)}
                </div>
                <p className="mt-5 text-base leading-relaxed text-slate-700">“{t.quote}”</p>
                <div className="mt-6 border-t border-slate-100 pt-5">
                  <p className="font-semibold text-[#144726]">{t.name}</p>
                  <p className="text-sm text-slate-500">{t.role}{t.role && t.company ? ' — ' : ''}{t.company}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
